import { DraftState, View } from '@/types';

export const setViewAction = (view: View) => (draft: DraftState) => {
  draft.view = view;
  draft.selectedConfigurationId = -1;
};
